var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "survey-container position-relative", attrs: { fluid: "" } },
    [
      _c("div", { staticClass: "top-right" }, [
        _c(
          "a",
          {
            ref: "closePage",
            staticClass:
              "close-page d-flex justify-content-center align-items-center",
            attrs: { href: "musicverse://survey_done" }
          },
          [
            _c("font-awesome-icon", {
              staticClass: "icon-close",
              attrs: { icon: ["fa", "times"] }
            })
          ],
          1
        ),
        _vm._v(" "),
        !_vm.isDone
          ? _c("div", { staticClass: "survey-info" }, [
              _c("span", [_vm._v(_vm._s(_vm.indexQuestion + 1))]),
              _vm._v(" "),
              _c("span", { staticClass: "mx-1" }, [_vm._v("of")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.listQuestion.length))])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.isDone
        ? _c("div", { staticClass: "survey-content" }, [
            _c("h1", { staticClass: "survey-title" }, [
              _vm._v(_vm._s(_vm.questionTitle))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "survey-question" }, [
              _vm._v(_vm._s(_vm.questionText))
            ]),
            _vm._v(" "),
            _c("small", { staticClass: "survey-hint" }, [
              _vm._v("Select a max of 3 choices only")
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "survey-option-list" },
              [
                _vm.listQuestion.length > 0
                  ? _vm._l(_vm.listOption, function(opt, index) {
                      return _c("li", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-control custom-checkbox option-checkbox"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedOptions,
                                  expression: "selectedOptions"
                                }
                              ],
                              key: index,
                              staticClass: "custom-control-input",
                              attrs: { type: "checkbox", id: "check-" + index },
                              domProps: {
                                value: opt,
                                checked: Array.isArray(_vm.selectedOptions)
                                  ? _vm._i(_vm.selectedOptions, opt) > -1
                                  : _vm.selectedOptions
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.selectedOptions,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = opt,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.selectedOptions = $$a.concat([
                                          $$v
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.selectedOptions = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.selectedOptions = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "custom-control-label option-label",
                                attrs: { for: "check-" + index }
                              },
                              [_vm._v(_vm._s(opt.text))]
                            )
                          ]
                        )
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showTextArea
                  ? _c("li", [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.customValue,
                            expression: "customValue"
                          }
                        ],
                        staticClass: "form-control custom-textarea",
                        attrs: { placeholder: "Type your answer" },
                        domProps: { value: _vm.customValue },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.customValue = $event.target.value
                          }
                        }
                      })
                    ])
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-block",
                class: {
                  "btn-primary": _vm.canSubmit,
                  "btn-secondary": !_vm.canSubmit
                },
                on: { click: _vm.next }
              },
              [_vm._v("Next")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isDone
        ? _c("div", { staticClass: "survey-success" }, [
            _c("h1", { staticClass: "success-title" }, [
              _vm._v("Thank You for Participating in Our Survey")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "success-info" }, [
              _vm._v(
                "Thank you for taking the time to complete this survey. Your feedback will definitely assist us in making MusicVerse a super app that meets the daily needs of Adventists. Take care and God bless!"
              )
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-primary btn-block",
                attrs: { href: "musicverse://survey_done" }
              },
              [_vm._v("Back to Home")]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75e9c643", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75e9c643","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SurveyPage.vue
// module id = null
// module chunks = 